import {createApiCall, fetchAllPages} from '../utils';
import {SERVICE_NAMES} from '../constants';
import type {ApiCallOptions, PaginatedResponse} from '../types';
import type {
    AttachmentView,
    AttachmentCreateRequest,
    AttachmentUpdateRequest,
    AttachmentListParams,
    RejectAttachmentRequest
} from './api.d';

export const attachmentApi = {
    getAttachment: (transactionId: string, attachmentId: string, options?: ApiCallOptions) => createApiCall<AttachmentView>(SERVICE_NAMES.ATTACHMENT, 'GET', `transactions/${transactionId}/attachments/${attachmentId}`)({...options}),

    createAttachment: (transactionId: string, recipientId: string, data: AttachmentCreateRequest, options?: ApiCallOptions) => createApiCall<AttachmentView>(SERVICE_NAMES.ATTACHMENT, 'POST', `transactions/${transactionId}/recipients/${recipientId}/attachments`)({...options, data}),

    updateAttachment: (transactionId: string, attachmentId: string, data: AttachmentUpdateRequest, options?: ApiCallOptions) => createApiCall<AttachmentView>(SERVICE_NAMES.ATTACHMENT, 'PUT', `transactions/${transactionId}/attachments/${attachmentId}`)({...options, data}),

    deleteAttachment: (transactionId: string, attachmentId: string, options?: ApiCallOptions) => createApiCall<void>(SERVICE_NAMES.ATTACHMENT, 'DELETE', `transactions/${transactionId}/attachments/${attachmentId}`)({...options}),

    rejectAttachment: (transactionId: string, attachmentId: string, data: RejectAttachmentRequest, options?: ApiCallOptions) => createApiCall<AttachmentView>(SERVICE_NAMES.ATTACHMENT, 'PUT', `transactions/${transactionId}/attachments/${attachmentId}/reject`)({...options, data}),

    getAttachments: (transactionId: string, params?: AttachmentListParams, options?: ApiCallOptions) => createApiCall<PaginatedResponse<AttachmentView>>(SERVICE_NAMES.ATTACHMENT, 'GET', `transactions/${transactionId}/attachments`)({...options, params}),

    getAllAttachments: (transactionId: string, params?: Omit<AttachmentListParams, 'page'>, options?: ApiCallOptions) => fetchAllPages(
        (paginationParams: AttachmentListParams, opts?: ApiCallOptions) => attachmentApi.getAttachments(transactionId, paginationParams, opts),
        params || {},
        options
    ),

    getAttachmentsByRecipientId: (transactionId: string, recipientId: string, params?: AttachmentListParams, options?: ApiCallOptions) => createApiCall<PaginatedResponse<AttachmentView>>(SERVICE_NAMES.ATTACHMENT, 'GET', `transactions/${transactionId}/recipients/${recipientId}/attachments`)({...options, params}),

    getAllAttachmentsByRecipientId: (transactionId: string, recipientId: string, params?: Omit<AttachmentListParams, 'page'>, options?: ApiCallOptions) => fetchAllPages(
        (paginationParams: AttachmentListParams, opts?: ApiCallOptions) => attachmentApi.getAttachmentsByRecipientId(transactionId, recipientId, paginationParams, opts),
        params || {},
        options
    ),

    getAttachmentById: (attachmentId: string, options?: ApiCallOptions) => createApiCall<AttachmentView>(SERVICE_NAMES.ATTACHMENT, 'GET', `transactions/attachments/by-id/${attachmentId}`)({...options})
};
